import { render, staticRenderFns } from "./HmrPageList.vue?vue&type=template&id=6f6c1e90"
import script from "./HmrPageList.vue?vue&type=script&lang=js"
export * from "./HmrPageList.vue?vue&type=script&lang=js"
import style0 from "./HmrPageList.vue?vue&type=style&index=0&id=6f6c1e90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports